import { CustomTooltipProps } from '@tremor/react'
import React from 'react'

import { DONUT_CHART_MIN_VALUE } from 'consts/charts'

import { formatDashboardNumber } from '../utils/formatDashboardNumber'

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const info = payload[0].payload
    const value = info.quantity !== undefined ? info.quantity : info.value
    const numeric = typeof value === 'number' && value <= DONUT_CHART_MIN_VALUE ? 0 : value
    const formattedValue = typeof numeric === 'number' ? formatDashboardNumber(numeric) : numeric

    return (
      <div
        className="bg-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-3"
        style={{
          fontFamily: 'Montserrat, sans-serif',
          minWidth: '200px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        }}
      >
        <div
          className={`w-3 h-3 rounded-full ${
            info.color === 'gray' ? 'bg-gray-400' : `bg-${info.color}-500`
          }`}
        />
        <span
          className="text-gray-800 text-sm font-normal flex-1"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          {label}
        </span>
        <span
          className="text-gray-800 text-sm font-medium"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          {formattedValue}
        </span>
      </div>
    )
  }
  return null
}

export default CustomTooltip
